
import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import { FilmFormValues } from "@/types/inventory";
import { FilmBasicFields } from "./form-fields/FilmBasicFields";
import { FilmDetailsFields } from "./form-fields/FilmDetailsFields";
import { ExpirationDateFields } from "./form-fields/ExpirationDateFields";
import { FilmNotesField } from "./form-fields/FilmNotesField";
import { useTranslation } from "@/hooks/useTranslation";

interface AddFilmFormProps {
  form: UseFormReturn<FilmFormValues>;
  onSubmit: (values: FilmFormValues) => Promise<void>;
  isEditing?: boolean;
}

export function AddFilmForm({ form, onSubmit, isEditing = false }: AddFilmFormProps) {
  const { t } = useTranslation();
  
  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <FilmBasicFields form={form} />
        <FilmDetailsFields form={form} />
        <ExpirationDateFields form={form} />
        <FilmNotesField form={form} />
        <Button type="submit" className="w-full">
          {isEditing ? t("update_film") : t("add_film")}
        </Button>
      </form>
    </Form>
  );
}
